// extracted by mini-css-extract-plugin
export default {"card":"z3-z"};